'use client'

import { AuthLedgerAppNotChosen } from '@/features/Auth/ui/AuthLegderErrorsModal/AuthLedgerAppNotChosen'
import { AuthLedgerAppNotConnected } from '@/features/Auth/ui/AuthLegderErrorsModal/AuthLedgerAppNotConnected'
import { AuthLedgerNotAvailable } from '@/features/Auth/ui/AuthLegderErrorsModal/AuthLedgerNotAvailable'
import { WalletAdapterNetwork, WalletError } from '@solana/wallet-adapter-base'
import { getDerivationPath } from '@solana/wallet-adapter-ledger'
import { ConnectionProvider, WalletProvider as WProvider } from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'
import { clusterApiUrl } from '@solana/web3.js'
import React, { ReactNode, useCallback, useMemo, useState } from 'react'
import { LedgerWalletAdapter, PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets'
import { getUser } from '@/features/Auth/auth.hooks'
import { getStorageKey } from '@/shared/helpers/localStorage'

export function WalletProvider({ children }: {
  children: ReactNode;
}) {
  const network = WalletAdapterNetwork.Mainnet
  const [errorOpen, setErrorOpen] = useState('')
  const user = getUser()

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter(),
      new LedgerWalletAdapter({
        derivationPath: getDerivationPath(0),
      }),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [network],
  )

  const endpoint = useMemo(() => clusterApiUrl(network), [network])

  const onWalletError = useCallback((e: WalletError) => {
    if (e.message) {
      if (e.message.toString().includes('0x5515')) {
        setErrorOpen('not-available')
      }

      if (e.message.toString().includes('0x6d02')) {
        setErrorOpen('not-solana')
      }

      if (e.message.toString().includes('Access denied to use Ledger device')) {
        setErrorOpen('access-denied')
      }
    }
  }, [])

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WProvider wallets={wallets} autoConnect={!!user} onError={onWalletError} localStorageKey={getStorageKey('godefi:wallet:provider')}>
        <WalletModalProvider>
          {children}
          <AuthLedgerNotAvailable open={errorOpen === 'not-available'} onClose={() => setErrorOpen('')} />
          <AuthLedgerAppNotChosen open={errorOpen === 'not-solana'} onClose={() => setErrorOpen('')} />
          <AuthLedgerAppNotConnected open={errorOpen === 'access-denied'} onClose={() => setErrorOpen('')} />
        </WalletModalProvider>
      </WProvider>
    </ConnectionProvider>
  )
}
